import {
  OwnUpGridContainer,
  OwnUpGridWrapper,
  PropsWithTheme
} from '@rategravity/own-up-component-library';
import React from 'react';
import styled from 'styled-components';
import { PostSnippet } from '../../../types';
import { PostCard } from '../../post-card';
import { HomeSection } from '../home-section';

export interface FeaturePosts {
  featurePosts?: PostSnippet[];
  title: string;
  cardStyles?: {
    textAlign?: string;
    backgroundColor?: string;
    padding?: string;
    boxShadow?: string;
    borderRadius: string;
  };
}

export interface FeaturePost extends PostSnippet {
  cardStyles: FeaturePosts['cardStyles'];
}

const CardsWrapper = styled.div`
  padding-top: ${({ theme }: PropsWithTheme<{}>) => `${theme.spacing(4)}px`};
  margin-bottom: ${({ theme }: PropsWithTheme<{}>) => `${theme.spacing(12)}px`};
`;

export const FeaturePosts = ({ featurePosts, title, cardStyles }: FeaturePosts) =>
  featurePosts && featurePosts?.length > 0 ? (
    <HomeSection title={title} textAlign={cardStyles?.padding}>
      <CardsWrapper>
        <OwnUpGridWrapper>
          <OwnUpGridContainer variant="legacy">
            {featurePosts.map((featurePost, index) => (
              <PostCard {...featurePost} cardStyles={cardStyles} key={index} />
            ))}
          </OwnUpGridContainer>
        </OwnUpGridWrapper>
      </CardsWrapper>
    </HomeSection>
  ) : null;
